import { FormBase } from 'core/components';

export default class NikoTemplateMissingProductNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'missingProductNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_MISSING_PRODUCT_NOTE_MODAL.MISSING_PRODUCT_NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_MISSING_PRODUCT_NOTE_MODAL.MISSING_PRODUCT_NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}
